import { Modal, Form, Row, Col, Input, Select, Button } from "antd";
import { doc, setDoc, getFirestore } from "firebase/firestore";
import {
  getAuth,
  signInWithEmailAndPassword,
  updateEmail,
  updatePassword,
} from "firebase/auth";

import {
  validateFullName,
  validateEmail,
  validatePhone,
  validatePassword,
} from "./validations";

import { logUserAction } from "../../logs";
import { roles, decrypt, APP_VERSION } from "../../utils";

const { Option } = Select;

export const EditUser = ({ data, isModalOpen, setIsModalOpen, updateData }) => {
  const [form] = Form.useForm();
  const db = getFirestore();
  const auth = getAuth();

  const handleEdit = async (values) => {
    const sessionEmail = await decrypt(localStorage.getItem("id"));
    const sessionPassword = await decrypt(localStorage.getItem("key"));
    const userRef = doc(db, "user", data.key);
    if (values.name) {
      await setDoc(userRef, { name: values.name }, { merge: true });
    }

    if (values.surname) {
      await setDoc(userRef, { surname: values.surname }, { merge: true });
    }

    if (values.phone) {
      await setDoc(userRef, { phone: values.phone }, { merge: true });
    }

    if (values.role) {
      await setDoc(userRef, { role: values.role }, { merge: true });
    }

    if (values.status) {
      await setDoc(userRef, { status: values.status }, { merge: true });
    }

    if (values.email && values.password) {
      await signInWithEmailAndPassword(auth, data.email.toLowerCase(), data.password)
        .then(() => {
          updateEmail(auth.currentUser, values.email.toLowerCase()).then(() => {
            updatePassword(auth.currentUser, values.password).then(() => {
              signInWithEmailAndPassword(
                auth,
                sessionEmail,
                sessionPassword
              ).then(() => {
                setDoc(userRef, { email: values.email.toLowerCase() }, { merge: true });
                setDoc(userRef, { password: values.password }, { merge: true });
              });
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (values.email) {
      await signInWithEmailAndPassword(auth, data.email.toLowerCase(), data.password)
        .then(() => {
          updateEmail(auth.currentUser, values.email.toLowerCase()).then(() => {
            signInWithEmailAndPassword(
              auth,
              sessionEmail,
              sessionPassword
            ).then(() => {
              setDoc(userRef, { email: values.email.toLowerCase() }, { merge: true });
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (values.password) {
      await signInWithEmailAndPassword(auth, data.email.toLowerCase(), data.password)
        .then(() => {
          updatePassword(auth.currentUser, values.password).then(() => {
            signInWithEmailAndPassword(
              auth,
              sessionEmail,
              sessionPassword
            ).then(() => {
              setDoc(userRef, { password: values.password }, { merge: true });
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    updateData();
    form.resetFields();
    logUserAction(db, auth, "EDIT_USER", auth.currentUser.uid, null, null, APP_VERSION);
    setIsModalOpen(false);
  };
  return (
    <>
      {!data ? null : (
        <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          title="Editar información del usuario"
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleEdit}
            autoComplete="off"
            requiredMark
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  name="name"
                  label="Nombre"
                  rules={[
                    {
                      required: false,
                    },
                    {
                      validator: validateFullName,
                    },
                  ]}
                >
                  <Input placeholder={data.name} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  name="surname"
                  label="Apellido"
                  rules={[
                    {
                      required: false,
                    },
                    {
                      validator: validateFullName,
                    },
                  ]}
                >
                  <Input placeholder={data.surname} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: false,
                    },
                    {
                      validator: validateEmail,
                    },
                  ]}
                >
                  <Input placeholder={data.email} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  name="phone"
                  label="Telefono"
                  rules={[
                    {
                      required: false,
                    },
                    {
                      validator: validatePhone,
                    },
                  ]}
                >
                  <Input placeholder={data.phone} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  name="password"
                  label="Contraseña"
                  rules={[
                    {
                      required: false,
                    },
                    {
                      validator: validatePassword,
                    },
                  ]}
                >
                  <Input placeholder={data.password} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  name="role"
                  label="Rol"
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Select placeholder="Seleccione una opcion">
                    {Object.values(roles).map((role, index) => <Option key={index} value={role}>{role}</Option>)}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  name="status"
                  label="Estado"
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Select placeholder="selecciona una opcion">
                    <Option
                      key={"Activo"}
                      value={true}
                      label={"Activo"}
                      name={"Activo"}
                    >
                      Activo
                    </Option>
                    <Option
                      key={"Inactivo"}
                      value={false}
                      label={"Inactivo"}
                      name={"Inactivo"}
                    >
                      Inactivo
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item className="footer-btn-modal">
              <Button onClick={() => setIsModalOpen(false)} size="large" className="btnCancel">
                Cancelar
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="btnOK button-right"
              >
                Editar
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};
